import React from 'react';
import * as Fi from 'react-icons/fi';
import cn from 'classnames';
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';

import { Skeletons } from 'ui/components/skeleton';
import { useDispatch, useSelector } from 'react-redux';
import { Fulfillment } from 'services/action';

const initialState = {
  showDelete: false,
};

export const Action = ({ data, onSubmit }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state.Form);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Fulfillment.Show']
  );

  const dummy = Array.from({ length: 4 }, (v, i) => i);

  const [{ showDelete }, setState] = React.useState(initialState);

  const $handleClose = () => {
    setState((prevState) => ({ ...prevState, showDelete: false }));
  };

  const $handleDelete = async () => {
    const del = await Dispatch(Fulfillment.$delete(data?.id));
    if (del?.message === 'success') {
      $handleClose();
      History.replace('/sales/fulfillment');
    }
  };

  const $handleCheck = async () => {
    const req = await Dispatch(Fulfillment.$check(data?.id));
    if (req?.message === 'success') {
      onSubmit();
    }
  };

  const $handleComplete = async () => {
    const req = await Dispatch(Fulfillment.$complete(data?.id));
    if (req?.message === 'success') {
      onSubmit();
    }
  };

  const StandardAction = () => {
    return (
      data?.document_status === 'fulfilled' && (
        <>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id={`tooltip-top`}>Checked</Tooltip>}
          >
            <button
              className={cn('btn btn-success px-2 py-1')}
              onClick={$handleCheck}
            >
              <Fi.FiCheckCircle size="17" className="me-2" /> Checked
            </button>
          </OverlayTrigger>

          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id={`tooltip-top`}>Perbaharui</Tooltip>}
          >
            <Link
              to={`/delivery/fulfillment/${data?.id}/update`}
              className={cn('btn btn-primary px-2')}
            >
              <Fi.FiEdit size="17" />
            </Link>
          </OverlayTrigger>

          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id={`tooltip-top`}>Hapus</Tooltip>}
          >
            <button
              className={cn('btn btn-danger px-2')}
              onClick={() =>
                setState((prevState) => ({ ...prevState, showDelete: true }))
              }
            >
              <Fi.FiTrash2 size="17" />
            </button>
          </OverlayTrigger>
        </>
      )
    );
  };

  return (
    <div className="d-flex align-items-center gap-1 px-3 px-md-0 pb-2 pb-md-0">
      {StateLoading ? (
        dummy?.map((d, i) => <Skeletons key={i} height="35px" width="35px" />)
      ) : (
        <>
          <StandardAction />

          {data?.document_status === 'checked' && (
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id={`tooltip-top`}>Complete</Tooltip>}
            >
              <button
                className={cn('btn btn-success px-2 py-1')}
                onClick={$handleComplete}
              >
                <Fi.FiCheckCircle size="17" className="me-2" /> Complete
              </button>
            </OverlayTrigger>
          )}
        </>
      )}

      {/* modal delete */}
      <Modal
        show={showDelete}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Data yang sudah dihapus tidak bisa dipulihkan
          </p>

          {/* {isError ? (
            <div className="invalid-feedback" style={{ display: 'block' }}>
              {isError?.id}
            </div>
          ) : null} */}
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={$handleClose}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={$handleDelete}
                disabled={StateForm?.loading}
              >
                Hapus
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
